import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useLocation, useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

const APP_NAME = "MandatePro";

function resolvePageTitle(pathname: string): string {
  if (pathname === "/login") return "Login";
  if (pathname === "/forgot-password") return "Forgot Password";
  if (pathname.startsWith("/auth")) return "Mandate Authentication";
  if (pathname.startsWith("/retailer/profile")) return "My Profile";
  if (pathname.startsWith("/retailer/kyc")) return "KYC";
  if (pathname.startsWith("/retailer/create-mandate")) return "Create Mandate";
  if (pathname.startsWith("/retailer/mandates")) return "My Mandates";
  if (pathname.startsWith("/retailer/installments")) return "Installments";
  if (pathname.startsWith("/retailer/wallet")) return "Wallet";
  if (pathname.startsWith("/retailer/dashboard")) return "Dashboard";
  if (pathname.startsWith("/admin/profile")) return "My Profile";
  if (pathname.startsWith("/admin/retailers")) return "Retailers";
  if (pathname.startsWith("/admin/kyc")) return "KYC Verification";
  if (pathname.startsWith("/admin/wallets")) return "Wallets";
  if (pathname.startsWith("/admin/installments")) return "Installments";
  if (pathname.startsWith("/admin/mandates")) return "All Mandates";
  if (pathname.startsWith("/admin/dashboard")) return "Dashboard";
  if (pathname.startsWith("/admin/logs")) return "Logs";
  if (pathname.startsWith("/admin/reports")) return "Reports";
  if (pathname.startsWith("/admin/settings")) return "Settings";
  return "Page Not Found";
}

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  useEffect(() => {
    document.title = `${resolvePageTitle(location.pathname)} — ${APP_NAME}`;
  }, [location.pathname]);
  return element;
}